import type { Messages } from './en';

/** Textos de la fase D (vida): setmanada, guardiola, necessitats i capricis, anuncis, fitxes, exposició, escolta i hamburgueseria. */
export const caLife: Pick<Messages, 'life'> = {
  life: {
    mapNames: {} as Record<string, string>,
    zones: {
      fastFood: 'Burger Corner',
    },
    objects: {
      life_piggy: 'Guardiola',
      life_fastfood: 'Burger Corner',
      life_adscreen: 'Pantalla d’anuncis',
    },
    npc: {} as Record<string, string>,
    items: {
      umbrella: { name: 'Paraigua', desc: 'T’evita mullar-te quan plou. Els dies de pluja és una necessitat!' },
    } as Record<string, { name: string; desc: string }>,

    need: 'Necessitat',
    want: 'Caprici',
    mom: 'Mama',
    coins: (n: number) => `${n}🪙`,

    allowance: {
      title: '💰 Setmanada',
      text: 'Bon dia! Aquí tens la setmanada: **100 monedes**.\nCom la repartiràs? Una part per gastar, una per a la guardiola i una per a regals.',
      split: 'Planegem-ho',
      hint: 'Toca − i + per moure monedes. Ha de sumar 100.',
      spend: '🛍️ Per gastar',
      piggy: '🐷 Guardiola',
      gift: '🎁 Fons de regals',
      presets: { balanced: '⚖️ Equilibrat', saver: '🐷 Estalviador', spender: '🛍️ Malgastador' },
      left: (n: number) => (n === 0 ? '✅ Les 100 monedes ja tenen feina!' : n > 0 ? `A ${n} monedes encara els falta feina` : `Sobren ${-n} monedes`),
      confirm: 'Aquest és el meu pla',
      momSaver: 'Ostres, quant estalvies! Els diumenges afegeixo un 10 % al que tinguis a la guardiola. Ja veuràs com creix!',
      momBalanced: 'Un pla ben equilibrat. Gastar una mica, estalviar una mica i compartir una mica.',
      momSpender: 'Això és molt per gastar! Tu decideixes, però recorda: quan s’acaba, s’acaba fins dissabte que ve.',
    },

    interest: {
      title: '🐷 L’extra del diumenge',
      text: (add: number, total: number) =>
        `La mama dona un cop d’ull a la guardiola i hi afegeix **${add} monedes**: el 10 % del que has estalviat.\nAra n’hi ha **${total}** a dins!\n\nAixí és com un banc paga «interessos»: els diners que deixes estalviats creixen sols.`,
      empty: 'La mama mira la teva guardiola: és buida. «Cada diumenge afegeixo un 10 % al que hagis estalviat. Fins i tot 10 monedes creixerien!»',
    },

    piggy: {
      text: (piggy: number, coins: number) => `Un porquet rosa amb una ranura per a monedes. A dins: **${piggy}🪙**. A la butxaca: **${coins}🪙**.`,
      in: (n: number) => `Posar-hi ${n}🪙`,
      out: (n: number) => `Treure’n ${n}🪙`,
      all: 'Posar-ho tot',
      done: (piggy: number) => `Clinc! Ara la guardiola té ${piggy}🪙.`,
      outWarn: 'Treure diners no està malament; només pregunta’t: és per a una necessitat o per a un caprici?',
      wallet: '👛 Obrir el moneder',
    },

    nw: {
      title: 'Pregunta ràpida',
      ask: (item: string) => `Abans de pagar: **${item}** és una necessitat o un caprici?`,
      right: (item: string, kind: string) => `Correcte! ${item} és: **${kind}**.`,
      wrong: (item: string, kind: string) => `Mmm, ${item} sol ser: **${kind}**.`,
      needWhy: 'Les necessitats et mantenen sa, segur i a punt per anar a l’escola.',
      wantWhy: 'Els capricis són extres agradables. Està bé comprar-los, però planeja’ls abans.',
      buy: 'Comprar-ho',
    },

    ad: {
      sources: { tv: '📺 Anunci de la tele', mall: '🏬 Pantalla del centre comercial', phone: '📱 Finestra emergent del mòbil' },
      flash: 'OFERTA LIMITADA!',
      only: 'NOMÉS AVUI!',
      was: (n: number) => `Abans ${n}🪙`,
      now: (n: number) => `ARA ${n}🪙`,
      timer: (s: number) => `L’oferta s’acaba d’aquí a ${s}…`,
      buy: (n: number) => `Comprar ara (${n}🪙)`,
      wait: '⏳ Esperar fins demà',
      boughtLesson: (was: number, now: number) =>
        `Ho has comprat! Però torna-hi a mirar: el preu d’«abans ${was}» és inventat, i ${now} és el preu normal.\nEls anuncis fan servir paraules amb pressa com **LIMITADA** i **NOMÉS AVUI** perquè compris abans de pensar.`,
      waitLesson: 'Molt bé! Ho has afegit a la llista de desitjos. Un bon truc: espera un dia abans de comprar un caprici. Si demà encara el vols, encara el podràs comprar.',
      poor: 'No tens prou monedes… i tot i així l’anunci vol que sentis que ho necessites!',
    },

    wish: {
      title: '📝 La teva llista de desitjos',
      cheaper: (item: string, was: number, now: number) => `Te’n recordes de ${item} de l’anunci? Avui costa **${now}🪙** en lloc de ${was}🪙. L’oferta «limitada» no era tan limitada!`,
      forgot: (item: string) => `Et despertes i penses en ${item} de l’anunci… de fet, no ho necessites. T’has quedat les monedes!`,
      lesson: 'Esperar un dia t’ajuda a distingir una necessitat de debò d’un caprici passatger.',
      buy: (n: number) => `Comprar-ho ara per ${n}🪙`,
      skip: 'No, gràcies, em quedo les monedes',
      kept: 'Monedes estalviades. El teu jo del futur te’n dona les gràcies!',
    },

    wallet: {
      title: '👛 El meu moneder',
      menu: '👛 Moneder',
      pocket: 'Butxaca',
      piggy: 'Guardiola',
      gift: 'Fons de regals',
      budget: 'Pressupost d’aquesta setmana',
      spent: (s: number, b: number) => (b ? `${s} de ${b}🪙 gastades` : `${s}🪙 gastades (encara sense pla: la setmanada arriba dissabte)`),
      over: 'T’has passat del pressupost! Intenta esperar a la setmana que ve per als capricis.',
      donut: 'Necessitats i capricis d’aquesta setmana',
      none: 'Aquesta setmana encara no has gastat res.',
      allTime: (n: number, w: number) => `En total: ${n}🪙 en necessitats · ${w}🪙 en capricis`,
      wishes: 'Llista de desitjos',
      noWishes: 'Buida: no hi ha compres impulsives esperant.',
      quiz: (n: number) => `Encerts de necessitat o caprici: ${n}`,
      tip: '💡 Consell',
      tips: [
        'Paga’t a tu primer: posa monedes a la guardiola abans d’anar a comprar.',
        'Un caprici no és dolent: planeja’l i et farà encara més il·lusió quan te’l compris.',
        '«Abans 40, ara 25!»: el preu d’«abans» sovint és inventat.',
        'Els menús només et fan estalviar si vols tot el que porten.',
        'Estalviar 10 monedes a la setmana són 520 monedes a l’any.',
        'Abans de comprar, pregunta’t: ho necessito? Tinc lloc per guardar-ho? Ho voldré encara la setmana que ve?',
        'Compara el preu d’UN: 3 per 45 són 15 cadascun; 2 per 28 són 14 cadascun.',
      ],
    },

    ws: {
      kinds: { homework: '📒 Deures', quiz: '📝 Control', exam: '🧪 Examen' },
      gradeLabel: (g: number) => `${g}${g === 1 || g === 3 ? 'r' : g === 2 ? 'n' : g === 4 ? 't' : 'è'} curs`,
      progress: (i: number, n: number) => `Pregunta ${i} de ${n}`,
      types: { spell: '🔤 Lletrejar', cloze: '✏️ Omple el buit', math: '🪙 Mates amb diners', reading: '📖 Lectura', logic: '🧩 Lògica' },
      spellHint: 'Escolta i toca les lletres en ordre.',
      clozeHint: 'Tria la paraula que falta.',
      mathHint: 'Pensa-hi bé: fes servir paper de brut si vols!',
      readingHint: 'Llegeix el text i després respon.',
      logicHint: 'Troba el patró.',
      hear: '🔊 Escoltar',
      undo: '⌫ Desfer',
      next: 'Següent ▶',
      finish: 'Veure la meva nota',
      right: '✅ Correcte!',
      wrong: (a: string) => `❌ La resposta és: ${a}`,
      result: (s: number, n: number) => `${s} / ${n} correctes`,
      comments: { A: 'Feina excel·lent! 🌟', B: 'Bona feina: una mica més de pràctica!', C: 'Continua intentant-ho: els errors t’ajuden a aprendre.' },
      done: 'Lliurar',
      math: {
        items: ['onigiri', 'suc', 'llapis', 'adhesiu', 'quadern', 'clauer'],
        left: (a: number, item: string, b: number) => `Tens ${a} monedes. Compres un ${item} per ${b} monedes. Quantes monedes et queden?`,
        change: (n: number, item: string, p: number, pay: number) => `Compres ${n} × ${item} a ${p} monedes cadascun i pagues amb ${pay} monedes. Quant et tornen?`,
        discount: (item: string, p: number, d: number) => `Un ${item} costa ${p} monedes. Avui té un ${d}% de descompte. Quin és el preu nou?`,
        weeks: (x: number, item: string, y: number) => `Estalvies ${x} monedes cada setmana. Quantes setmanes necessites per comprar un ${item} de ${y} monedes?`,
        unit: (item: string, nA: number, pA: number, nB: number, pB: number) =>
          `Paquet A: ${nA} × ${item} per ${pA} monedes. Paquet B: ${nB} × ${item} per ${pB} monedes. Quant costa UN ${item} al paquet més barat?`,
        interest: (p: number) => `Tens ${p} monedes a la guardiola. La mama hi afegeix un 10% cada setmana (sobre el total nou). Quantes monedes tindràs al cap de 2 setmanes?`,
      },
      logic: (seq: string) => `Què ve després?  ${seq}, ?`,
    },

    desk: {
      portfolio: '🖼️ El meu portafoli',
      worksheet: 'La teva fitxa de deures és a punt: cinc preguntes per al teu curs.',
    },

    exhibit: {
      title: '🖼️ Exposició de treballs',
      titlePortfolio: '🖼️ El meu portafoli',
      today: 'Avui és el **dia de l’exposició** (成果展)! Cada quatre setmanes l’escola mostra el que han fet els alumnes. Les teves fitxes, dibuixos i segells són a la paret.',
      see: 'Veure el meu racó',
      works: 'Millors fitxes',
      noWorks: 'Encara no hi ha fitxes: fes els deures a l’escriptori.',
      drawings: 'Dibuixos de PixelBook',
      noDrawings: 'Encara no hi ha dibuixos: dibuixa alguna cosa a PixelBook amb el mòbil.',
      stamps: 'Segells del passaport',
      noStamps: 'Encara no hi ha segells: ves d’excursió i celebra les festes!',
      reward: (n: number) => `Als visitants els encanta el teu racó! +${n}⭐`,
      next: (w: number) => `Propera exposició: setmana ${w}`,
    },

    listen: {
      tab: '👂 Escoltar',
      pick: '👂 Escolta i tria',
      dict: '⌨️ Dictat',
      pickHint: 'Escolta i toca el que has sentit.',
      dictHint: 'Escolta i escriu el que sents.',
      play: '🔊 Reproduir',
      slow: '🐢 Lent',
      check: 'Comprovar',
      placeholder: 'Escriu aquí…',
      ok: 'Perfecte!',
      close: (a: string) => `Gairebé! Era: «${a}»`,
      bad: (a: string) => `No del tot. Era: «${a}»`,
      next: 'Següent ▶',
      streak: (n: number) => `🔥 Ratxa: ${n}`,
      shadow: '🎤 Digues-ho',
    },

    replay: { again: '🔊', slow: '🐢', mic: '🎤', listening: 'Escoltant…', good: 'Molt ben repetit!', retry: (h: string) => `He sentit «${h}». Torna-ho a provar!` },

    grade: { title: '🎒 Curs escolar', hint: 'Ajusta la dificultat dels deures i els exàmens.', names: ['3r', '4t', '5è', '6è'] },

    ff: {
      title: '🍔 Burger Corner',
      hint: 'Demana en anglès i compara preus!',
      menu: [
        { name: 'Hamburguesa amb formatge', desc: 'Calentona i et fa el pes', en: 'a cheeseburger' },
        { name: 'Patates fregides', desc: 'Salades i cruixents', en: 'some fries' },
        { name: 'Refresc de cola', desc: 'Molt dolç (molt de sucre!)', en: 'a cola' },
        { name: 'Menú', desc: 'Hamburguesa + patates + cola', en: 'the combo meal' },
        { name: '🥗 Wrap vegetal + llet de soja', desc: 'L’opció sana', en: 'a veggie wrap and a soy milk' },
      ],
      compare: '🧮 Menú o no?',
      compareText: (sum: number, combo: number) => `Hamburguesa + patates + cola per separat = **${sum}🪙**. El menú = **${combo}🪙**. Estalvies ${sum - combo}🪙… però només si vols les tres coses!`,
      water: 'Aigua gratis? Només cal demanar-la: “Can I have some water, please?”',
      cashier: 'Caixer',
      greet: 'Hi! Welcome to Burger Corner. What can I get for you?', // English practice
      prompt: 'Tria la manera educada de demanar:',
      wrong: ['El caixer parpelleja. “Sorry? Could you say that politely?”', 'Mmm, això sona una mica maleducat. Prova amb “Can I have…, please?”'],
      done: 'Here you go! Enjoy your meal!', // English practice
      poor: 'No tens prou monedes. Potser alguna cosa més barata?',
      healthy: 'Una tria sana! El teu cos t’ho agraeix. +2⭐',
      tooMuch: 'Allò duia molta sal i molt de sucre… et notes una mica pesat.',
      look: 'Només miro, gràcies',
      waterDone: 'Sure! Here’s a cup of water.', // English practice
    },

    save: {
      menu: '🔑 Codi de desament',
      title: '🔑 Codi de desament',
      exportHint: 'Copia aquest codi per guardar la partida o passar-la a un altre dispositiu.',
      copy: '📋 Copiar el codi',
      copied: 'Copiat!',
      importHint: 'Enganxa aquí un codi de desament per carregar aquella partida.',
      placeholder: 'Enganxa un codi…',
      load: '📥 Carregar aquest codi',
      bad: 'Aquest codi no funciona. Comprova que l’has copiat sencer.',
      confirm: 'Vols carregar aquesta partida? Se substituirà la partida actual.',
      startButton: '🔑 Carregar un codi de desament',
    },

    journal: {
      allowance: (split: string) => `He planejat la setmanada: ${split}`,
      exhibit: 'He ensenyat els meus treballs a l’exposició',
      waited: 'He esperat un dia en lloc de comprar per impuls',
      worksheet: (g: string) => `He tret una ${g} en una fitxa`,
    },
  },
};
